import React, { useState, useRef, useEffect } from "react";
import { IconButton, InputBase } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { motion } from "framer-motion";

type SearchProps = {
  setUserParams: (value: string) => void;
};

const AnimatedSearchBar: React.FC<SearchProps> = ({ setUserParams }) => {
  const [expanded, setExpanded] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);
  const debounceTimeout = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (expanded && inputRef.current) {
      inputRef.current.focus();
    }
  }, [expanded]);

  const toggleExpanded = () => {
    setExpanded((prev) => !prev);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchValue(value);

    // Clear previous timeout
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      setUserParams(value);
    }, 1000);
  };

  return (
    <motion.div
      initial={false}
      animate={{ width: expanded ? 300 : 56 }}
      transition={{ type: "spring", stiffness: 300, damping: 25 }}
      style={{
        height: 56,
        overflow: "hidden",
        borderRadius: 999,
        backgroundColor: "#d2f8c2",
        display: "flex",
        alignItems: "center",
        boxSizing: "border-box",
        justifyContent: "center",
        paddingLeft: expanded ? 16 : 0,
        paddingRight: expanded ? 8 : 0,
      }}
    >
      {expanded && (
        <InputBase
          inputRef={inputRef}
          placeholder="Search"
          value={searchValue}
          onChange={handleChange}
          sx={{
            flex: 1,
            fontFamily: "Poppins",
            fontSize: 16,
            height: "100%",
            "& input::placeholder": {
              color: "black",
            },
            color: "black",
          }}
          inputProps={{
            style: {
              padding: 0,
              height: "100%",
              color: "black",
            },
          }}
        />
      )}
      <IconButton onClick={toggleExpanded} sx={{ p: 1 }}>
        <SearchIcon sx={{ color: "black" }} />
      </IconButton>
    </motion.div>
  );
};

export default AnimatedSearchBar;
